export default __webpack_public_path__ + "static/6_29-3783fa5b72b13894b823f33ac4940e71.png";